import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  setBackButtonLabel,
  setResultsViewType,
  setEquipDisplayOption,
  setBackButtonLinkAction,
} from '../../../redux/actions/ui';
import { getBuildingName } from '../../../redux/selectors/buildings';
import EquipmentContainer from './EquipmentContainer';
import SensorContainer from './SensorContainer';
import TagsLoader from '../../loaders/TagsLoader';
import PointTypeLoader from '../../loaders/PointTypeLoader';
import EquipmentLoader from '../../loaders/EquipmentLoader';
import EquipTypeLoader from '../../loaders/EquipTypeLoader';

const mapStateToProps = (state, ownProps) => ({
  byEquipDisplayOption: state.ui.byEquipDisplayOption,
  buildingName: getBuildingName(state, ownProps.bid),
});

const mapDispatchToProps = (dispatch) => ({
  setBackButtonLabel: (label) => dispatch(setBackButtonLabel(label)),
  setResultsViewType: (type) => dispatch(setResultsViewType(type)),
  setEquipDisplayOption: (option) => dispatch(setEquipDisplayOption(option)),
  setBackButtonLink: (link) => dispatch(setBackButtonLinkAction(link)),
});

class EquipLevelContainer extends PureComponent {
  componentDidMount() {
    this.props.setEquipDisplayOption('name');
    this.props.setResultsViewType('Equip');
    this.props.setBackButtonLabel('< BACK TO BUILDING VIEW');
    this.props.setBackButtonLink(
      `/explore/buildings/${encodeURIComponent(this.props.buildingName)}?bid=${this.props.bid}`
    );
  }

  componentWillUnmount() {
    this.props.setResultsViewType('');
    this.props.setBackButtonLabel(null);
  }

  render() {
    const view =
      this.props.byEquipDisplayOption === 'sensor' ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <SensorContainer {...this.props} />
      ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <EquipmentContainer {...this.props} />
      );
    return (
      <>
        <PointTypeLoader />
        <TagsLoader />
        <EquipTypeLoader />
        <EquipmentLoader buildingId={this.props.bid} />
        {view}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EquipLevelContainer);
